export const firebaseConfig = {
	apiKey: 'AIzaSyBllv5o2H_7oVuNZN8Q6KU5KjVuXN-wkeE',
	authDomain: 'people-fashion.firebaseapp.com',
	projectId: 'people-fashion',
	storageBucket: 'people-fashion.appspot.com',
	messagingSenderId: '334667988154',
	appId: '1:334667988154:web:3fa1581250ba202c4b1683',
};
